import { inject } from '@angular/core';
import { CanActivateChildFn, Router, type CanActivateFn } from '@angular/router';
import Session from 'supertokens-web-js/recipe/session';


export const authGuard: CanActivateFn | CanActivateChildFn = async (route, state) => {

  const router: Router = inject(Router);
  const authenticated = await Session.doesSessionExist();
  if (authenticated) {
      return true
  }
  else {
      const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
      return router.parseUrl(`sign-in?${redirectURL}`);
  }
  
}
